import React, {Fragment} from 'react';
import ResponsiveImage from "@core/scripts/templates/ResponsiveImage.jsx";

export default function SeoRecommendations({
                                               recommendations,
                                               texts
                                           }) {
    return (
        <div className="recommendations">
            <div className="recommendations__headline">{texts.ada15_other_customers_bought}</div>
            <div className="recommendations__slider">
                <div className="recommendations__slider-content">
                    {recommendations.map((recommendation) => (
                        <a href={recommendation.productUrl} className="recommendations__slide">
                            <div className="recommendations__item-image-wrapper">
                                <ResponsiveImage
                                    image={recommendation.responsiveImage}
                                    alt={recommendation.title}
                                />
                            </div>
                            <div className="recommendations__item-title">{recommendation.title}</div>
                            <div className="recommendations__item-price">
                                <div className={'recommendations__price' + (recommendation.price.current.unknownPrice ? ' -unknown' : '') + (recommendation.price.current.former ? ' -reduced' : '')}>
                                    {!recommendation.price.current.uniquePrice && <div className="recommendations__multiple-prices">{texts.au_ab}</div>}
                                    <span>{recommendation.price.current.value}</span>
                                </div>
                                {recommendation.price.former &&
                                    <span>
                                        <span className="recommendations__former-price">
                                            {!recommendation.price.former.uniquePrice && <>{texts.au_ab}</>}
                                            {recommendation.price.former.value}
                                        </span>
                                        <span className="recommendations__price-reduction">
                                        -{recommendation.price.current.reduction}%
                                        </span>
                                    </span>
                                }
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
